import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c4defff&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1c4defff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4defff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4defff')) {
      api.createRecord('1c4defff', component.options)
    } else {
      api.reload('1c4defff', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c4defff&scoped=true", function () {
      api.rerender('1c4defff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/labelManagement/index.vue"
export default component.exports